export enum CashFlowPeriodType {
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  YEARLY = "YEARLY",
}

export interface CashFlowCategoryAmount {
  id: string;
  name: string;
  amount: number;
}

export interface CashFlowSectionResult {
  section: "OPERATING" | "INVESTING" | "FINANCING";
  categories: CashFlowCategoryAmount[];
  subtotal: number;
}

export interface CashFlowColumnResult {
  dateFrom: string;
  dateTo: string;
  sections: CashFlowSectionResult[];
  netCashFlow: number;
  openingBalance: number;
  closingBalance: number;
}

export interface CashFlowReportResponse {
  columns: CashFlowColumnResult[];
}
